import router from '../router'

let redirectingToLogin = false

/** 统一跳转登录页，避免并发 401 触发多次导航 */
export function redirectToLogin() {
  if (router.currentRoute.path === '/login') return
  if (redirectingToLogin) return
  redirectingToLogin = true
  router.replace('/login').catch(() => {}).finally(() => {
    setTimeout(() => {
      redirectingToLogin = false
    }, 300)
  })
}
